module.exports = __webpack_public_path__ + "img/business-guideIcon.a65d428f.svg";